export class Device {
  readonly id: string
  readonly name: string
  readonly mac_address: string
  readonly user_id: string
  readonly last_seen: Date
  readonly firmware_version: string
  readonly used_storage_percent: number
  readonly family_groups: string[]

  constructor (id: string, name: string, mac_address: string, user_id: string, last_seen: string, firmware_version: string, used_storage_percent: number, family_groups: string[]) {
    this.id = id
    this.name = name
    this.mac_address = mac_address
    this.user_id = user_id
    this.last_seen = new Date(last_seen)
    this.firmware_version = firmware_version
    this.used_storage_percent = used_storage_percent
    this.family_groups = family_groups
  }
}
